import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import {computed} from 'vue';
import {
    APP_ICON_BADGE_TYPE_TYPES,
    NOTIFICATION_POSITION_BOTTOM_LEFT,
    NOTIFICATION_POSITION_BOTTOM_RIGHT,
    NOTIFICATION_POSITION_TOP_LEFT,
    NOTIFICATION_POSITION_TOP_RIGHT,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import OperatorApplicationSwitchConfig from "~/operatorApplication/vue/config/OperatorApplicationSwitchConfig.vue";
import {__} from "~/ts/library/Translate";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationNotificationSoundConfig
    from "~/operatorApplication/vue/config/OperatorApplicationNotificationSoundConfig.vue";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";


const __default__ = {
    name: "OperatorApplicationConfigNotifications"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

let autoCloseDelay = computed(() => {
    let result = [];
    for (let i of [5, 10, 15, 30, 60]) {
        result.push({value: i, label: __("через %d секунд", i)});
    }
    return result;
});

let isNative = computed(() => {
    return OperatorApplicationPlatform.isNative;
});

let isFocusAvailable = computed(() => {
    return OperatorApplicationPlatformFactory.window.isFocusAvailable();
});

let notifyPositions = computed(() => {
    return [
        {label: __(__("справа снизу")), value: NOTIFICATION_POSITION_BOTTOM_RIGHT},
        {label: __(__("слева снизу")), value: NOTIFICATION_POSITION_BOTTOM_LEFT},
        {label: __(__("справа сверху")), value: NOTIFICATION_POSITION_TOP_RIGHT},
        {label: __(__("слева сверху")), value: NOTIFICATION_POSITION_TOP_LEFT},
    ];
});

let appIconBadgeTypes = computed(() => {
    return APP_ICON_BADGE_TYPE_TYPES.value;
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Всплывающие уведомления")), 1),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).newMessageNotificationsEnabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(configuration).newMessageNotificationsEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать уведомление о новых сообщениях')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(isNative))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(OperatorApplicationSwitchConfig, {
                modelValue: _unref(configuration).newMessageWindowFocus,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(configuration).newMessageWindowFocus) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)('Открывать окно на переднем плане при новом сообщении')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(OperatorApplicationSwitchConfig, {
                modelValue: _unref(configuration).newDialogWindowFocus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(configuration).newDialogWindowFocus) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)('Открывать окно на переднем плане при новом диалоге')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).offlineQuestionsNotificationsEnabled,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(configuration).offlineQuestionsNotificationsEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать уведомление о новых Offline-вопросах')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).targetClientNotificationsEnabled,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(configuration).targetClientNotificationsEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать уведомление о целевых посетителях')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).operatorStatusChangeNotificationsEnabled,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(configuration).operatorStatusChangeNotificationsEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать уведомление о смене статуса операторов')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(isFocusAvailable))
          ? (_openBlock(), _createBlock(OperatorApplicationSwitchConfig, {
              key: 1,
              modelValue: _unref(configuration).skipMessageNotificationWhenFocusedAndSelected,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(configuration).skipMessageNotificationWhenFocusedAndSelected) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)('Не показывать уведомления для открытого диалога')) + " ", 1),
                (_unref(configuration).skipMessageNotificationWhenFocusedAndSelected)
                  ? (_openBlock(), _createBlock(HelpBlock, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(__)('Уведомления не будут отображаться для открытого диалога, если окно приложения находится на переднем плане')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_unref(isNative))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(OperatorApplicationSwitchConfig, {
                modelValue: _unref(configuration).autoCloseNotificationsEnabled,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(configuration).autoCloseNotificationsEnabled) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)('Автоматическое скрытие всех уведомлений')) + " ", 1),
                  (_unref(configuration).autoCloseNotificationsEnabled)
                    ? (_openBlock(), _createBlock(InlineSelect, {
                        key: 0,
                        modelValue: _unref(configuration).autoCloseNotificationsDelay,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(configuration).autoCloseNotificationsDelay) = $event)),
                        options: _unref(autoCloseDelay).map(item => ({ value: item.value, label: item.label }))
                      }, null, 8, ["modelValue", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)("Расположение уведомлений")) + ": ", 1),
                  _createVNode(InlineSelect, {
                    modelValue: _unref(configuration).notificationPosition,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(configuration).notificationPosition) = $event)),
                    options: _unref(notifyPositions).map(item => ({ value: item.value, label: item.label }))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Звуковые уведомления")), 1),
        _createVNode(OperatorApplicationNotificationSoundConfig, {
          title: _unref(__)('Новый диалог'),
          modelValue: _unref(configuration).newDialogNotificationSound,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(configuration).newDialogNotificationSound) = $event)),
          "repeat-available": "",
          repeat: _unref(configuration).newDialogNotificationRepeat,
          "onUpdate:repeat": _cache[11] || (_cache[11] = ($event: any) => ((_unref(configuration).newDialogNotificationRepeat) = $event))
        }, null, 8, ["title", "modelValue", "repeat"]),
        _createVNode(OperatorApplicationNotificationSoundConfig, {
          title: _unref(__)('Новое сообщение'),
          modelValue: _unref(configuration).newMessageNotificationSound,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(configuration).newMessageNotificationSound) = $event)),
          "repeat-available": "",
          repeat: _unref(configuration).newMessageNotificationRepeat,
          "onUpdate:repeat": _cache[13] || (_cache[13] = ($event: any) => ((_unref(configuration).newMessageNotificationRepeat) = $event))
        }, null, 8, ["title", "modelValue", "repeat"]),
        _createVNode(OperatorApplicationNotificationSoundConfig, {
          title: _unref(__)('Новый целевой клиент'),
          modelValue: _unref(configuration).targetClientNotificationSound,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(configuration).targetClientNotificationSound) = $event))
        }, null, 8, ["title", "modelValue"]),
        _createVNode(OperatorApplicationNotificationSoundConfig, {
          title: _unref(__)('Новое сообщение в межоператорском чате'),
          modelValue: _unref(configuration).newCrossOperatorMessageNotificationSound,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(configuration).newCrossOperatorMessageNotificationSound) = $event)),
          "repeat-available": "",
          repeat: _unref(configuration).newCrossOperatorMessageNotificationRepeat,
          "onUpdate:repeat": _cache[16] || (_cache[16] = ($event: any) => ((_unref(configuration).newCrossOperatorMessageNotificationRepeat) = $event))
        }, null, 8, ["title", "modelValue", "repeat"]),
        (_unref(configuration).operatorStatusChangeNotificationsEnabled)
          ? (_openBlock(), _createBlock(OperatorApplicationNotificationSoundConfig, {
              key: 3,
              modelValue: _unref(configuration).operatorStatusChangeNotificationSound,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(configuration).operatorStatusChangeNotificationSound) = $event)),
              title: _unref(__)('Изменение статуса оператора')
            }, null, 8, ["modelValue", "title"]))
          : _createCommentVNode("", true),
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Счетчики")), 1),
        (_unref(isNative))
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("Счетчик на иконке приложения")) + ": ", 1),
                _createVNode(InlineSelect, {
                  modelValue: _unref(configuration).appIconBadgeType,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(configuration).appIconBadgeType) = $event)),
                  options: _unref(appIconBadgeTypes).map(item => ({ value: item.id, label: item.label.toLowerCase() }))
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)("Счетчик в списке контактов приложения")) + ": ", 1),
            _createVNode(InlineSelect, {
              modelValue: _unref(configuration).buddyListBadgeType,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(configuration).buddyListBadgeType) = $event)),
              options: _unref(appIconBadgeTypes).map(item => ({ value: item.id, label: item.label.toLowerCase() }))
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})